import { useToasts } from "@certn/cascadia";
import { useTranslation } from "react-i18next";
import { object, string } from "yup";

import { useFormSubmit } from "../../../hooks/api/useSubmit";

export function useGeneralFeedbackSchema() {
  const { t } = useTranslation();
  return object({
    topic: string().required().label(t("Topic")),
    message: string().required().label(t("Message")),
  });
}

export function useTopicList() {
  const { t } = useTranslation();

  return [
    {
      name: t("Question"),
      value: "QUESTION",
    },
    {
      name: t("Suggestion"),
      value: "SUGGESTION",
    },
    {
      name: t("Compliment"),
      value: "COMPLIMENT",
    },
    {
      name: t("Language request"),
      value: "LANGUAGE_REQUEST",
    },
    {
      name: t("Other"),
      value: "OTHER",
    },
  ];
}

export function useGeneralFeedbackFormSubmit() {
  const { show } = useToasts();
  const { t } = useTranslation();

  return useFormSubmit("/internal/people/submit-feedback/", {
    onSuccess: () =>
      show({
        title: t("Feedback sent"),
        type: "info",
      }),
    raiseError: true,
  });
}
